

import React from "react";
import Modal from "../../../components/modal";

const SetSalaryModal = ({ show, onClose, user }) => {
    if (!user) return null;

    return (
        <Modal show={show} onClose={onClose} heading={`Set Salary - ${user.emp_id}`} size="xl">
            <div className="row">

                {/* ================= Employee Salary ================= */}
                <div className="col-md-6">
                    <div className="card min-height-253">
                        <div className="card-header d-flex justify-content-between">
                            <h6 className="mb-0">Employee Salary</h6>
                            <button className="btn btn-sm btn-primary">
                                <i className="ti ti-plus"></i>
                            </button>
                        </div>

                        <div className="card-body">
                            <div className="d-flex text-sm">
                                <div className="col-4">
                                    <b>Payslip Type</b>
                                    <div>{user.payroll_type || "--"}</div>
                                </div>
                                <div className="col-4">
                                    <b>Salary</b>
                                    <div>₹ {user.salary || "--"}</div>
                                </div>
                                <div className="col-4">
                                    <b>Account</b>
                                    <div>{user.account_number || "--"}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ================= Allowance ================= */}
                <div className="col-md-6">
                    <div className="card min-height-253">
                        <div className="card-header d-flex justify-content-between">
                            <h6 className="mb-0">Allowance</h6>
                            <button className="btn btn-sm btn-primary">
                                <i className="ti ti-plus"></i>
                            </button>
                        </div>
                        <div className="card-body text-center">
                            No Allowance Found!
                        </div>
                    </div>
                </div>

                {/* ================= Commission ================= */}
                <div className="col-md-6">
                    <div className="card min-height-253">
                        <div className="card-header d-flex justify-content-between">
                            <h6 className="mb-0">Commission</h6>
                            <button className="btn btn-sm btn-primary">
                                <i className="ti ti-plus"></i>
                            </button>
                        </div>
                        <div className="card-body text-center">
                            No Commission Found!
                        </div>
                    </div>
                </div>

                {/* ================= Loan ================= */}
                <div className="col-md-6">
                    <div className="card min-height-253">
                        <div className="card-header d-flex justify-content-between">
                            <h6 className="mb-0">Loan</h6>
                            <button className="btn btn-sm btn-primary">
                                <i className="ti ti-plus"></i>
                            </button>
                        </div>
                        <div className="card-body text-center">
                            No Loan Data Found!
                        </div>
                    </div>
                </div>

                {/* ================= Saturation Deduction ================= */}
                <div className="col-md-6">
                    <div className="card min-height-253">
                        <div className="card-header d-flex justify-content-between">
                            <h6 className="mb-0">Saturation Deduction</h6>
                            <button className="btn btn-sm btn-primary">
                                <i className="ti ti-plus"></i>
                            </button>
                        </div>
                        <div className="card-body text-center">
                            No Saturation Deduction Found!
                        </div>
                    </div>
                </div>

                {/* ================= Other Payment ================= */}
                <div className="col-md-6">
                    <div className="card min-height-253">
                        <div className="card-header d-flex justify-content-between">
                            <h6 className="mb-0">Other Payment</h6>
                            <button className="btn btn-sm btn-primary">
                                <i className="ti ti-plus"></i>
                            </button>
                        </div>
                        <div className="card-body text-center">
                            No Other Payment Data Found!
                        </div>
                    </div>
                </div>

                {/* ================= Overtime ================= */}
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between">
                            <h6 className="mb-0">Overtime</h6>
                            <button className="btn btn-sm btn-primary">
                                <i className="ti ti-plus"></i>
                            </button>
                        </div>
                        <div className="card-body text-center">
                            No Overtime Data Found!
                        </div>
                    </div>
                </div>

            </div>
        </Modal>
    );
};

export default SetSalaryModal;
